/**
 * 编辑器「导出动图」统一配置：4 个入口 = 格式 × 尺寸，全部透明背景。
 */

export type AnimationExportFormat = "gif" | "webp";

export type AnimationExportSize = 512 | 1024;

export interface AnimationExportVariant {
  id: "gif-512" | "webp-512" | "gif-1024" | "webp-1024";
  format: AnimationExportFormat;
  size: AnimationExportSize;
  /** 下拉菜单文案 */
  label: string;
  /** 下载文件名后缀，如 `-1024` */
  fileSuffix: string;
}

/** 编码 / 截帧公共默认：全透明 + 高品质采帧（canvas 直读 alpha） */
export const ANIMATION_EXPORT_DEFAULTS = {
  transparentBackground: true,
  highQualityCapture: true,
  /** WebP 每帧质量 */
  quality: 0.9,
  /** gif.js：1 最高 */
  gifQuality: 10,
} as const;

export const ANIMATION_EXPORT_VARIANTS: readonly AnimationExportVariant[] = [
  {
    id: "gif-512",
    format: "gif",
    size: 512,
    label: "导出 GIF",
    fileSuffix: "",
  },
  {
    id: "webp-512",
    format: "webp",
    size: 512,
    label: "导出 WebP",
    fileSuffix: "",
  },
  {
    id: "gif-1024",
    format: "gif",
    size: 1024,
    label: "导出 GIF（1024）",
    fileSuffix: "-1024",
  },
  {
    id: "webp-1024",
    format: "webp",
    size: 1024,
    label: "导出 WebP（1024）",
    fileSuffix: "-1024",
  },
] as const;

export function getAnimationExportVariant(
  id: AnimationExportVariant["id"],
): AnimationExportVariant {
  const variant = ANIMATION_EXPORT_VARIANTS.find((v) => v.id === id);
  if (!variant) {
    throw new Error(`未知导出动图选项: ${id}`);
  }
  return variant;
}
